const name = 'donut';


const contents = `
  <circle cx="31" cy="41" r="29"/>
  <circle fill="#FFF" cx="31" cy="41" r="20.5"/>
  <circle cx="31" cy="41" r="10"/>
`;


/** @type {import ('./types').Icon} */
const icon = {
  name,
  contents,
};

export default icon;

